// Hard-coded related skills data for the experiment

const relatedSkills = {
  accounting: ['financial-analysis', 'financial-accounting', 'audit', 'general-accounting'],
  'business-analysis': [
    'spreadsheet-software',
    'financial-analysis',
    'critical-thinking',
    'data-visualization-software',
  ],
  'business-psychology': ['learning', 'adaptability', 'user-experience-design', 'organization-development'],
  'cloud-computing': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  communication: ['business-communication', 'writing', 'social-media', 'emotional-intelligence'],
  'computer-architecture': [
    'internet-of-things',
    'network-architecture',
    'distributed-computing-architecture',
    'hardware-design',
  ],
  'computer-graphics': ['graphic-design', 'virtual-reality', 'interactive-design', 'computer-graphic-techniques'],
  'computer-network': ['network-security', 'internet-of-things', 'network-model', 'network-architecture'],
  'computer-programming': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  'data-analysis': ['microsoft-excel', 'power-bi', 'financial-analysis', 'data-analysis-software'],
  'data-management': ['sql', 'data-structure', 'big-data', 'data-warehousing'],
  database: ['sql', 'nosql', 'database-design', 'data-administration'],
  'design-and-product': ['product-management', 'product-design', 'user-research', 'product-strategy'],
  devops: ['devops-tools', 'continuous-integration', 'continuous-delivery'],
  entrepreneurship: ['strategy', 'problem-solving', 'product-management', 'planning'],
  'fields-of-mathematics': ['linear-algebra', 'calculus', 'game-theory', 'mathematical-analysis'],
  finance: ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  'human-computer-interaction': ['user-experience', 'user-research', 'virtual-reality', 'interactive-design'],
  'human-resources': ['leadership-development', 'conflict-management', 'recruitment', 'people-development'],
  'machine-learning': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  management: ['strategy', 'problem-solving', 'leadership-development', 'change-management'],
  marketing: ['strategy', 'digital-marketing', 'social-media', 'negotiation'],
  'mobile-application-development': [
    'java-programming-language',
    'android-software-development',
    'ios',
    'swift-programming-language',
  ],
  'operating-system': ['linux', 'system-security', 'systems-design', 'system-software'],
  'probability-and-statistics': ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  'research-and-design': ['problem-solving', 'critical-thinking', 'user-experience-design', 'market-research'],
  sales: ['strategy', 'salesforce', 'negotiation', 'e-commerce'],
  'security-engineering': ['network-security', 'cyberattacks', 'cryptography', 'system-security'],
  'software-engineering': [
    'agile-software-development',
    'software-testing',
    'docker-software',
    'scrum-software-development',
  ],
  'statistical-programming': ['python-programming-language', 'sql', 'r-programming-language', 'postgresql'],
  'strategy-and-operations': ['project-management', 'strategy', 'product-management', 'change-management'],
  'supply-chain-and-logistics': ['planning', 'supply-chain-systems', 'procurement', 'customer-support'],
  'theoretical-computer-science': ['data-structure', 'algorithms', 'software-architecture', 'cryptography'],
  'visualization-graphic': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
  ],
  'web-development': ['javascript', 'html-and-css', 'react-javascript-library', 'front-end-web-development'],
  'account-management': ['strategy', 'salesforce', 'negotiation', 'e-commerce'],
  'accounting-software': ['financial-analysis', 'financial-accounting', 'audit', 'general-accounting'],
  'accounts-payable-and-receivable': ['financial-analysis', 'financial-accounting', 'audit', 'general-accounting'],
  adaptability: ['strategy', 'problem-solving', 'product-management', 'planning'],
  advertising: ['strategy', 'digital-marketing', 'business-communication', 'writing'],
  'advertising-sales': ['strategy', 'digital-marketing', 'business-communication', 'writing'],
  'agile-software-development': ['software-testing', 'docker-software', 'scrum-software-development', 'jira-software'],
  algebra: ['linear-algebra', 'calculus', 'game-theory', 'mathematical-analysis'],
  algorithms: ['data-structure', 'software-architecture', 'cryptography', 'systems-design'],
  'amazon-web-services': ['google-cloud-platform', 'microsoft-azure', 'kubernetes', 'ibm-cloud-computing'],
  'android-software-development': [
    'java-programming-language',
    'ios',
    'swift-programming-language',
    'mobile-development-tools',
  ],
  angular: ['javascript', 'html-and-css', 'react-javascript-library', 'front-end-web-development'],
  apache: ['sql', 'data-structure', 'big-data', 'data-warehousing'],
  'application-development': [
    'agile-software-development',
    'software-testing',
    'docker-software',
    'scrum-software-development',
  ],
  'application-security': ['network-security', 'cyberattacks', 'cryptography', 'system-security'],
  'applied-machine-learning': [
    'deep-learning',
    'artificial-neural-network',
    'natural-language-processing',
    'computer-vision',
  ],
  'applied-mathematics': ['linear-algebra', 'calculus', 'game-theory', 'mathematical-analysis'],
  arcgis: ['python-programming-language', 'sql', 'r-programming-language', 'postgresql'],
  'artificial-neural-network': [
    'deep-learning',
    'problem-solving',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  audit: ['financial-analysis', 'financial-accounting', 'general-accounting', 'cost-accounting'],
  'back-end-web-development': ['javascript', 'html-and-css', 'react-javascript-library', 'front-end-web-development'],
  banking: ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  'bayesian-network': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  'bayesian-statistics': ['bioinformatics', 'statistics', 'epidemiology', 'regression'],
  'behavioral-economics': ['learning', 'adaptability', 'user-experience-design', 'organization-development'],
  benefits: ['leadership-development', 'conflict-management', 'recruitment', 'people-development'],
  'big-data': ['sql', 'data-structure', 'data-warehousing', 'business-intelligence'],
  'billing-and-invoicing': ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  bioinformatics: ['statistics', 'bayesian-statistics', 'epidemiology', 'regression'],
  biostatistics: ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  blockchains: ['risk-management', 'investment-management', 'financial-technology', 'budget-management'],
  'brand-management': ['strategy', 'digital-marketing', 'social-media', 'negotiation'],
  'budget-management': ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  'business-communication': ['writing', 'social-media', 'emotional-intelligence', 'storytelling'],
  'business-design': ['problem-solving', 'critical-thinking', 'user-experience-design', 'market-research'],
  'business-development': ['strategy', 'salesforce', 'negotiation', 'e-commerce'],
  'business-intelligence': ['sql', 'data-structure', 'big-data', 'spreadsheet-software'],
  'business-process-management': ['project-management', 'strategy', 'problem-solving', 'product-management'],
  'business-research': ['problem-solving', 'critical-thinking', 'user-experience-design', 'market-research'],
  'business-to-business': ['strategy', 'salesforce', 'negotiation', 'e-commerce'],
  'business-transformation': [
    'spreadsheet-software',
    'financial-analysis',
    'critical-thinking',
    'data-visualization-software',
  ],
  'c-programming-language-family': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'cplusplus',
  ],
  calculus: ['linear-algebra', 'game-theory', 'mathematical-analysis', 'differential-equations'],
  'cash-management': ['financial-analysis', 'financial-accounting', 'audit', 'general-accounting'],
  'change-management': ['project-management', 'strategy', 'problem-solving', 'product-management'],
  'clinical-data-management': ['sql', 'data-structure', 'big-data', 'data-warehousing'],
  'cloud-api': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'cloud-applications': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'cloud-engineering': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'cloud-infrastructure': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'cloud-load-balancing': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'cloud-management': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'cloud-platforms': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'cloud-storage': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  collaboration: ['strategy', 'problem-solving', 'business-communication', 'writing'],
  'communication-design': ['problem-solving', 'critical-thinking', 'user-experience-design', 'market-research'],
  'computational-logic': ['data-structure', 'algorithms', 'software-architecture', 'cryptography'],
  'computational-thinking': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  'computer-graphic-techniques': ['graphic-design', 'virtual-reality', 'interactive-design', 'graphics-software'],
  'computer-programming-tools': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  'computer-security-incident-management': ['network-security', 'cyberattacks', 'cryptography', 'system-security'],
  'computer-vision': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  'conflict-management': ['strategy', 'problem-solving', 'leadership-development', 'change-management'],
  'continuous-delivery': ['devops-tools', 'continuous-integration'],
  'continuous-integration': ['devops-tools', 'continuous-delivery'],
  'contract-management': ['project-management', 'strategy', 'product-management', 'change-management'],
  'corporate-accounting': ['financial-analysis', 'innovation', 'financial-accounting', 'audit'],
  'correlation-and-dependence': ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  'cost-accounting': ['financial-analysis', 'financial-accounting', 'audit', 'general-accounting'],
  cplusplus: [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  creativity: ['strategy', 'problem-solving', 'product-management', 'critical-thinking'],
  'critical-thinking': ['project-management', 'strategy', 'spreadsheet-software', 'problem-solving'],
  cryptography: ['network-security', 'data-structure', 'algorithms', 'cyberattacks'],
  culture: ['strategy', 'problem-solving', 'leadership-development', 'change-management'],
  'customer-analysis': [
    'spreadsheet-software',
    'financial-analysis',
    'critical-thinking',
    'data-visualization-software',
  ],
  'customer-relationship-management': ['strategy', 'blockchains', 'digital-marketing', 'risk-management'],
  'customer-success': ['project-management', 'strategy', 'product-management', 'change-management'],
  'customer-support': ['business-communication', 'writing', 'social-media', 'emotional-intelligence'],
  cyberattacks: ['network-security', 'cryptography', 'system-security', 'application-security'],
  'data-administration': ['sql', 'nosql', 'database-design', 'database-theory'],
  'data-analysis-software': ['microsoft-excel', 'power-bi', 'financial-analysis', 'matlab'],
  'data-architecture': ['sql', 'data-structure', 'big-data', 'data-warehousing'],
  'data-mining': ['microsoft-excel', 'power-bi', 'financial-analysis', 'data-analysis-software'],
  'data-mining-and-machine-learning-software': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  'data-model': ['sql', 'data-structure', 'big-data', 'data-warehousing'],
  'data-structure': ['sql', 'big-data', 'algorithms', 'software-architecture'],
  'data-visualization-software': [
    'spreadsheet-software',
    'tableau-software',
    'financial-analysis',
    'critical-thinking',
  ],
  'data-warehousing': ['sql', 'data-structure', 'big-data', 'data-model'],
  'database-application': ['sql', 'data-structure', 'big-data', 'data-warehousing'],
  'database-design': ['sql', 'nosql', 'data-administration', 'database-theory'],
  'database-theory': ['sql', 'data-structure', 'algorithms', 'software-architecture'],
  'decision-making': ['strategy', 'problem-solving', 'product-management', 'leadership-development'],
  'deep-learning': [
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
    'computer-vision',
  ],
  'descriptive-statistics': ['microsoft-excel', 'power-bi', 'bioinformatics', 'statistics'],
  'devops-tools': ['continuous-integration', 'continuous-delivery'],
  'differential-equations': ['linear-algebra', 'calculus', 'game-theory', 'mathematical-analysis'],
  'digital-marketing': ['strategy', 'social-media', 'negotiation', 'advertising'],
  'dimensionality-reduction': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  'distributed-computing-architecture': [
    'internet-of-things',
    'network-architecture',
    'hardware-design',
    'microarchitectures',
  ],
  django: ['javascript', 'html-and-css', 'react-javascript-library', 'front-end-web-development'],
  'docker-software': ['agile-software-development', 'software-testing', 'scrum-software-development', 'jira-software'],
  'e-commerce': ['strategy', 'salesforce', 'negotiation', 'business-development'],
  econometrics: ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  'emotional-intelligence': ['strategy', 'problem-solving', 'business-communication', 'writing'],
  'entrepreneurial-finance': ['strategy', 'problem-solving', 'product-management', 'planning'],
  epidemiology: ['bioinformatics', 'statistics', 'bayesian-statistics', 'regression'],
  estimation: ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  experiment: ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  'exploratory-data-analysis': ['microsoft-excel', 'power-bi', 'spreadsheet-software', 'bioinformatics'],
  'extract--transform--load': ['sql', 'data-structure', 'big-data', 'data-warehousing'],
  'feature-engineering': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  'financial-accounting': ['financial-analysis', 'audit', 'general-accounting', 'cost-accounting'],
  'financial-analysis': ['microsoft-excel', 'power-bi', 'spreadsheet-software', 'critical-thinking'],
  'financial-management': ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  'financial-technology': ['blockchains', 'risk-management', 'investment-management', 'budget-management'],
  forecasting: ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  'front-end-web-development': ['javascript', 'html-and-css', 'react-javascript-library', 'web-design'],
  'full-stack-web-development': ['javascript', 'html-and-css', 'react-javascript-library', 'front-end-web-development'],
  'game-theory': ['linear-algebra', 'calculus', 'mathematical-analysis', 'differential-equations'],
  'general-accounting': ['financial-analysis', 'financial-accounting', 'audit', 'cost-accounting'],
  'generally-accepted-accounting-principles': [
    'financial-analysis',
    'financial-accounting',
    'audit',
    'general-accounting',
  ],
  geometry: ['linear-algebra', 'calculus', 'game-theory', 'mathematical-analysis'],
  geovisualization: [
    'tableau-software',
    'data-visualization-software',
    'interactive-data-visualization',
    'spatial-analysis',
  ],
  'google-app-engine': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'google-cloud-platform': ['amazon-web-services', 'microsoft-azure', 'kubernetes', 'ibm-cloud-computing'],
  'graph-theory': ['linear-algebra', 'calculus', 'game-theory', 'mathematical-analysis'],
  'graphic-design': ['virtual-reality', 'interactive-design', 'computer-graphic-techniques', 'graphics-software'],
  'graphics-software': ['graphic-design', 'virtual-reality', 'interactive-design', 'computer-graphic-techniques'],
  'hardware-design': [
    'internet-of-things',
    'network-architecture',
    'distributed-computing-architecture',
    'microarchitectures',
  ],
  'html-and-css': ['javascript', 'react-javascript-library', 'front-end-web-development', 'web-design'],
  'human-factors-security': ['network-security', 'user-experience', 'cyberattacks', 'cryptography'],
  'human-resources-operations': ['leadership-development', 'innovation', 'conflict-management', 'recruitment'],
  'ibm-cloud-computing': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'industrial-relations': ['business-communication', 'writing', 'social-media', 'leadership-development'],
  influencing: ['strategy', 'digital-marketing', 'business-communication', 'writing'],
  innovation: ['strategy', 'problem-solving', 'product-management', 'critical-thinking'],
  'inside-sales': ['strategy', 'salesforce', 'negotiation', 'innovation'],
  'interactive-data-visualization': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'spatial-analysis',
  ],
  'interactive-design': ['graphic-design', 'user-experience', 'user-research', 'virtual-reality'],
  'internet-of-things': ['network-security', 'agile-software-development', 'software-testing', 'docker-software'],
  'investment-management': ['blockchains', 'risk-management', 'financial-technology', 'budget-management'],
  ios: [
    'java-programming-language',
    'android-software-development',
    'swift-programming-language',
    'mobile-development-tools',
  ],
  'java-programming-language': [
    'python-programming-language',
    'javascript',
    'c-programming-language-family',
    'cplusplus',
  ],
  javascript: [
    'python-programming-language',
    'java-programming-language',
    'html-and-css',
    'c-programming-language-family',
  ],
  'jira-software': ['agile-software-development', 'software-testing', 'docker-software', 'scrum-software-development'],
  journalism: ['business-communication', 'writing', 'social-media', 'emotional-intelligence'],
  kubernetes: ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'ibm-cloud-computing'],
  'leadership-development': ['strategy', 'problem-solving', 'change-management', 'emotional-intelligence'],
  learning: ['strategy', 'problem-solving', 'product-management', 'change-management'],
  'linear-algebra': ['calculus', 'game-theory', 'mathematical-analysis', 'differential-equations'],
  linux: ['system-security', 'systems-design', 'system-software', 'system-programming'],
  'looker-software': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
  ],
  'machine-learning-algorithms': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  'management-accounting': ['financial-analysis', 'financial-accounting', 'audit', 'general-accounting'],
  'market-analysis': ['strategy', 'digital-marketing', 'social-media', 'negotiation'],
  'market-research': ['strategy', 'problem-solving', 'product-management', 'critical-thinking'],
  'marketing-design': ['problem-solving', 'critical-thinking', 'user-experience-design', 'market-research'],
  'marketing-management': ['business-communication', 'writing', 'social-media', 'emotional-intelligence'],
  'marketing-psychology': ['learning', 'adaptability', 'user-experience-design', 'organization-development'],
  'marketing-technology': ['strategy', 'digital-marketing', 'social-media', 'negotiation'],
  'markov-model': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  'material-handling': ['planning', 'supply-chain-systems', 'procurement', 'customer-support'],
  'mathematical-analysis': ['linear-algebra', 'calculus', 'game-theory', 'differential-equations'],
  matlab: ['microsoft-excel', 'power-bi', 'financial-analysis', 'data-analysis-software'],
  'media-production': ['business-communication', 'writing', 'social-media', 'emotional-intelligence'],
  'media-strategy': ['strategy', 'digital-marketing', 'business-communication', 'writing'],
  'mergers-and-acquisitions': ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  microarchitectures: ['data-structure', 'algorithms', 'software-architecture', 'cryptography'],
  'microsoft-azure': ['amazon-web-services', 'google-cloud-platform', 'kubernetes', 'ibm-cloud-computing'],
  'microsoft-excel': ['power-bi', 'financial-analysis', 'data-analysis-software', 'matlab'],
  'mobile-development-tools': [
    'java-programming-language',
    'android-software-development',
    'ios',
    'swift-programming-language',
  ],
  'natural-language-processing': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'computer-vision',
  ],
  negotiation: ['strategy', 'digital-marketing', 'business-communication', 'writing'],
  'network-analysis': ['linear-algebra', 'calculus', 'game-theory', 'mathematical-analysis'],
  'network-architecture': [
    'network-security',
    'internet-of-things',
    'network-model',
    'distributed-computing-architecture',
  ],
  'network-model': ['network-security', 'internet-of-things', 'network-architecture', 'networking-hardware'],
  'network-security': ['cyberattacks', 'cryptography', 'internet-of-things', 'system-security'],
  'networking-hardware': ['network-security', 'internet-of-things', 'network-model', 'network-architecture'],
  nosql: ['sql', 'database-design', 'data-administration', 'database-theory'],
  'operational-analysis': ['spreadsheet-software', 'financial-analysis', 'critical-thinking', 'planning'],
  'operations-management': ['project-management', 'strategy', 'product-management', 'change-management'],
  'operations-research': ['project-management', 'strategy', 'artificial-neural-network', 'problem-solving'],
  'organization-development': ['strategy', 'problem-solving', 'product-management', 'leadership-development'],
  'other-cloud-platforms-and-tools': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'other-programming-languages': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  'other-web-frameworks': ['javascript', 'html-and-css', 'react-javascript-library', 'front-end-web-development'],
  'other-web-programming-languages': [
    'javascript',
    'html-and-css',
    'react-javascript-library',
    'front-end-web-development',
  ],
  payments: ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  'people-analysis': ['spreadsheet-software', 'leadership-development', 'financial-analysis', 'critical-thinking'],
  'people-development': ['strategy', 'problem-solving', 'product-management', 'leadership-development'],
  'people-management': ['project-management', 'strategy', 'problem-solving', 'product-management'],
  'performance-management': ['project-management', 'strategy', 'product-management', 'change-management'],
  'persona-research': ['problem-solving', 'critical-thinking', 'user-experience-design', 'market-research'],
  planning: ['strategy', 'problem-solving', 'product-management', 'leadership-development'],
  'plot-graphics': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
  ],
  postgresql: ['python-programming-language', 'sql', 'r-programming-language', 'sas-software'],
  'power-bi': ['microsoft-excel', 'financial-analysis', 'data-analysis-software', 'matlab'],
  'probability-distribution': ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  'problem-solving': ['strategy', 'artificial-neural-network', 'product-management', 'leadership-development'],
  'process-analysis': [
    'spreadsheet-software',
    'financial-analysis',
    'critical-thinking',
    'data-visualization-software',
  ],
  procurement: ['planning', 'supply-chain-systems', 'customer-support', 'stock-management'],
  'product-design': ['product-management', 'user-research', 'product-strategy', 'product-lifecycle'],
  'product-development': ['product-management', 'product-design', 'user-research', 'product-strategy'],
  'product-lifecycle': ['product-management', 'product-design', 'user-research', 'product-strategy'],
  'product-management': ['project-management', 'strategy', 'problem-solving', 'change-management'],
  'product-marketing': ['product-management', 'product-design', 'user-research', 'product-strategy'],
  'product-strategy': ['product-management', 'product-design', 'user-research', 'product-lifecycle'],
  'professional-development': ['strategy', 'problem-solving', 'leadership-development', 'change-management'],
  'programming-principles': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  'project-management': ['strategy', 'product-management', 'change-management', 'critical-thinking'],
  'prospecting-and-qualification': ['strategy', 'salesforce', 'negotiation', 'e-commerce'],
  'public-relations': ['strategy', 'digital-marketing', 'business-communication', 'writing'],
  'python-programming-language': ['sql', 'java-programming-language', 'javascript', 'c-programming-language-family'],
  'r-programming-language': ['python-programming-language', 'sql', 'postgresql', 'sas-software'],
  'react-javascript-library': ['javascript', 'html-and-css', 'front-end-web-development', 'web-design'],
  recruitment: ['leadership-development', 'conflict-management', 'people-development', 'human-resources-operations'],
  regression: ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  'regulations-and-compliance': ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  'reinforcement-learning': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  resilience: ['strategy', 'problem-solving', 'product-management', 'planning'],
  'retail-sales': ['strategy', 'salesforce', 'negotiation', 'innovation'],
  'retail-store-operations': ['planning', 'supply-chain-systems', 'procurement', 'customer-support'],
  'risk-management': ['blockchains', 'investment-management', 'financial-technology', 'budget-management'],
  'sales-systems': ['strategy', 'salesforce', 'negotiation', 'e-commerce'],
  salesforce: ['strategy', 'negotiation', 'e-commerce', 'business-development'],
  'sas-software': ['python-programming-language', 'sql', 'r-programming-language', 'postgresql'],
  'scala-programming-language': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  'scientific-visualization': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
  ],
  'scrum-software-development': ['agile-software-development', 'software-testing', 'docker-software', 'jira-software'],
  'search-engine-optimization': ['strategy', 'digital-marketing', 'social-media', 'negotiation'],
  'securities-sales': ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  'securities-trading': ['blockchains', 'risk-management', 'investment-management', 'financial-technology'],
  'security-software': ['network-security', 'cyberattacks', 'cryptography', 'system-security'],
  'security-strategy': ['network-security', 'cyberattacks', 'cryptography', 'system-security'],
  'semantic-web': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'small-data': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'social-media': ['strategy', 'digital-marketing', 'business-communication', 'writing'],
  'software-architecture': ['data-structure', 'agile-software-development', 'software-testing', 'algorithms'],
  'software-as-a-service': ['amazon-web-services', 'google-cloud-platform', 'microsoft-azure', 'kubernetes'],
  'software-defined-networking': ['network-security', 'internet-of-things', 'network-model', 'network-architecture'],
  'software-engineering-tools': [
    'agile-software-development',
    'software-testing',
    'docker-software',
    'scrum-software-development',
  ],
  'software-framework': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  'software-testing': ['agile-software-development', 'docker-software', 'scrum-software-development', 'jira-software'],
  'software-visualization': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
  ],
  'spatial-analysis': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
  ],
  'spatial-data-analysis': ['microsoft-excel', 'power-bi', 'financial-analysis', 'data-analysis-software'],
  'spreadsheet-software': [
    'financial-analysis',
    'critical-thinking',
    'data-visualization-software',
    'business-intelligence',
  ],
  sql: ['python-programming-language', 'data-structure', 'r-programming-language', 'big-data'],
  'statistical-analysis': ['microsoft-excel', 'power-bi', 'spreadsheet-software', 'financial-analysis'],
  'statistical-machine-learning': [
    'deep-learning',
    'artificial-neural-network',
    'applied-machine-learning',
    'natural-language-processing',
  ],
  'statistical-tests': ['bioinformatics', 'statistics', 'bayesian-statistics', 'epidemiology'],
  'statistical-visualization': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
  ],
  statistics: ['bioinformatics', 'bayesian-statistics', 'epidemiology', 'regression'],
  'stock-management': ['planning', 'supply-chain-systems', 'procurement', 'customer-support'],
  storytelling: ['business-communication', 'writing', 'social-media', 'emotional-intelligence'],
  strategy: ['project-management', 'digital-marketing', 'problem-solving', 'product-management'],
  'supplier-relationship-management': ['planning', 'supply-chain-systems', 'procurement', 'customer-support'],
  'supply-chain-systems': ['planning', 'procurement', 'customer-support', 'stock-management'],
  'survey-creation': ['problem-solving', 'critical-thinking', 'user-experience-design', 'market-research'],
  'swift-programming-language': [
    'java-programming-language',
    'android-software-development',
    'ios',
    'mobile-development-tools',
  ],
  'system-programming': [
    'python-programming-language',
    'java-programming-language',
    'javascript',
    'c-programming-language-family',
  ],
  'system-security': ['network-security', 'linux', 'cyberattacks', 'cryptography'],
  'system-software': ['linux', 'system-security', 'systems-design', 'system-programming'],
  'systems-design': ['data-structure', 'algorithms', 'linux', 'software-architecture'],
  'tableau-software': [
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
    'spatial-analysis',
  ],
  'talent-management': ['leadership-development', 'conflict-management', 'recruitment', 'people-development'],
  taxes: ['financial-analysis', 'financial-accounting', 'audit', 'general-accounting'],
  'technical-product-management': ['product-management', 'product-design', 'user-research', 'product-strategy'],
  tensorflow: ['deep-learning', 'artificial-neural-network', 'applied-machine-learning', 'natural-language-processing'],
  training: ['leadership-development', 'learning', 'adaptability', 'user-experience-design'],
  'transportation-operations-management': ['planning', 'supply-chain-systems', 'procurement', 'customer-support'],
  'user-experience': ['user-research', 'virtual-reality', 'interactive-design', 'human-factors-security'],
  'user-experience-design': ['problem-solving', 'critical-thinking', 'learning', 'adaptability'],
  'user-research': ['product-management', 'user-experience', 'product-design', 'product-strategy'],
  'virtual-reality': ['graphic-design', 'user-experience', 'user-research', 'interactive-design'],
  'visualization-computer-graphics': [
    'tableau-software',
    'data-visualization-software',
    'geovisualization',
    'interactive-data-visualization',
  ],
  'web-design': ['javascript', 'html-and-css', 'react-javascript-library', 'front-end-web-development'],
  'web-development-tools': ['javascript', 'html-and-css', 'react-javascript-library', 'front-end-web-development'],
  writing: ['business-communication', 'social-media', 'emotional-intelligence', 'storytelling'],
};

export { relatedSkills };
